import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import I18n from 'I18n';
import styled from 'styled-components';
import { CompanySizeOption } from 'signup-constants/signupData/CompanySizeOption';
import UIFormLabel from 'UIComponents/form/UIFormLabel';
import UISelect from 'UIComponents/input/UISelect';
import { Data } from '../signup-data/DATA';
import { useSignupData } from '../signup-data/useSignupData';
import { Step } from '../views/Step';
export const StyledFormLabel = styled(UIFormLabel).withConfig({
  displayName: "CompanySizeSelect__StyledFormLabel",
  componentId: "sc-3ysbvp-0"
})(["font-size:16px !important;font-weight:400 !important;margin-bottom:8px;"]);
export const CompanySizeSelect = () => {
  const companySizeOptions = Object.values(CompanySizeOption).map(option => {
    return {
      text: I18n.text(`views.${Data.CompanySize}.options.${option}`),
      value: option
    };
  });
  const {
    setData
  } = useSignupData(Data.CompanySize);
  const stepKey = Step.OnePageSignup;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(StyledFormLabel, {
      children: I18n.text(`views.${stepKey}.companySize.label`)
    }), /*#__PURE__*/_jsx("div", {
      className: "CompanySizeSelect",
      children: /*#__PURE__*/_jsx(UISelect, {
        anchorType: "button",
        options: companySizeOptions,
        placeholder: I18n.text(`views.${Data.CompanySize}.placeholder_onepage`),
        onChange: event => {
          setData(event.target.value);
        }
      })
    })]
  });
};